import type { Theme } from '@mui/material';
import type { Components } from '@mui/material/styles';

export default function MUITable(theme: Theme): Components['MuiTable'] {
  return {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadius,
      },
    },
  };
}
